import React, { useState, useEffect, useRef } from 'react'
import ResultsOnPage from "./ResultsOnPage";
import PageNavi from "./PageNavi";
import DropdownFilter from "./Filters/DropdownFilter";
import TextFilter from './Filters/TextFilter';
import DropdownTree from "../CustomComponents/DropdownTree";
import Api from '../../services/Api';
import axios from 'axios';
import { IconButton } from '@fluentui/react';
import ExportButton from './ExportButton';
import { Stack } from '@fluentui/react';
import SiteItemsList from './SiteItemsList';
import { createAndDownloadCsv, mapEnumToFilterValues } from '../../helpers/HelperMethods';
import { AttentionType, ConfidentialityLevel, ProvisioningStatus, SiteStatus, TasksFilter } from '../../GlobalConst/globalEnums';

const CancelToken = axios.CancelToken;

const SiteList = () => {

    const apiAddress = '/SitesPanel';

    const exportFields = [{
        label: 'Site Name',
        value: 'title'
    }, {
        label: 'Site Url',
        value: 'url'
    }, {
        label: 'Administrator',
        value: 'owner'
    }, {
        label: 'Co-Administrators',
        value: 'coOwners'
    }, {
        label: 'Expiration Date',
        value: 'expirationDate'
    },{
        label: 'Site Status',
        value: 'status'
    },{
        label: 'Technical Status',
        value: 'provisioningStatus'
    },{
        label: 'External Collaboration',
        value: 'externalCollaboration'
    },{
        label: 'Sensitivity Label',
        value: 'confidentiality'
    },{
        label: 'Organization',
        value: 'organization'
    },{
        label: 'Site Audience',
        value: 'siteAudience'
    },{
        label: 'Template',
        value: 'template'
    },{
        label: 'Gdpr',
        value: 'gdpr'
    },{
        label: 'Sensitive Gdpr',
        value: 'sensitiveGdpr'
    },{
        label: 'Business Area Level',
        value: 'businessAreaLevel'
    },{
        label: 'Business Division Level',
        value: 'businessDivisionLevel'
    },{
        label: 'Litigation Hold',
        value: 'litigationHold'
    }];

    const [isLoading, setIsLoading] = useState(true);
    const [isExporting, setIsExporting] = useState(false);
    const [sites, setSites] = useState([]);
    const [totalResults, setTotalResults] = useState(0);
    const [onPage, setOnPage] = useState(20);
    const [pageUrlFilter, setPageUrlFilter] = useState(1);
    const [filters, setFilters] = useState({});
    const [orderBy, setOrderBy] = useState({ fieldName: '', isDescending: false });
    const cancelSource = useRef(null);

    useEffect(() => {
        return updateResults();
    }, [onPage, pageUrlFilter, filters, orderBy])
    
    const loadSites = (posts) => {
        setSites(posts);
        setIsLoading(false);
    }

    const loadTotalCount = (total) => {
        setTotalResults(total);
    }

    const updateResults = () => {
        setIsLoading(true);

        let url = `${apiAddress}?page=${pageUrlFilter}&onPage=${onPage}`;

        const filterUrl = Object.keys(filters).reduce((queryString, filterField) => {
            const filterText = filters[filterField];
            if(filterText) {
                queryString += `&${filterField}=${encodeURIComponent(filterText)}`;
            }
            return queryString;
        }, '');

        let orderByUrl = '';
        if(orderBy.fieldName) {
            orderByUrl = `&orderBy=${orderBy.fieldName}&isDesc=${orderBy.isDescending}`;
        }

        url = url + filterUrl + orderByUrl;

        if (cancelSource.current) {
            cancelSource.current.cancel();
        }

        cancelSource.current = CancelToken.source();

        Api.get(url, {
            cancelToken: cancelSource.current.token
        })
        .then(res => res.data)
        .then(posts => {
            loadSites(posts.results);
            loadTotalCount(posts.totalCount);
        })
        .catch(err => {});

        return () => {
            cancelSource.current.cancel();
        }
    }

    const onFilterChange = (fieldName, value) => {
        setFilters({
            ...filters,
            [fieldName]: value
        });
        setPageUrlFilter(1);
    }

    const handleNoSelection = () => {
        loadSites([]);
        loadTotalCount(0);
    }

    const sortItems = (fieldName, isDescending) => {
        setOrderBy({
            fieldName,
            isDescending
        });
    }

    const exportSites = () => {
        setIsExporting(true);

        let url = `${apiAddress}?forExport=${1}`;

        const filterUrl = Object.keys(filters).reduce((queryString, filterField) => {
            const filterText = filters[filterField];
            if(filterText) {
                queryString += `&${filterField}=${encodeURIComponent(filterText)}`;
            }
            return queryString;
        }, '');

        let orderByUrl = '';
        if(orderBy.fieldName) {
            orderByUrl = `&orderBy=${orderBy.fieldName}&isDesc=${orderBy.isDescending}`;
        }

        url = url + filterUrl + orderByUrl;

        if (cancelSource.current) {
            cancelSource.current.cancel();
        }

        cancelSource.current = CancelToken.source();

        Api.get(url, {
            cancelToken: cancelSource.current.token
        })
        .then(res => res.data)
        .then(posts => {
            createAndDownloadCsv(posts, "sites", exportFields);
            setIsExporting(false);
        })
        .catch(err => {});

        return () => {
            cancelSource.current.cancel();
        }
    }

    return(
        <div>
            <div className="filters">
                <div className="cell">
                    <TextFilter
                        fieldName='title'
                        fieldLabel='Site Name'
                        onChange={onFilterChange}
                        />
                </div>
                <div className="cell">
                    <TextFilter
                        fieldName='url'
                        fieldLabel='Site URL'
                        onChange={onFilterChange}
                        />
                </div>
                <div className="cell">
                    <TextFilter
                        fieldName='owner'
                        fieldLabel='Administrator'
                        onChange={onFilterChange}
                        />
                </div>
                <div className="cell">
                    <TextFilter
                        fieldName='channelName'
                        fieldLabel='Private & Shared channels'
                        onChange={onFilterChange}
                        />
                </div>
                <div className="cell">
                    <DropdownFilter 
                        fieldName='siteStatus'
                        //urlFetch='/SiteStatus?q=all'
                        title='Site Status'
                        onChange = {onFilterChange}
                        noselection = {handleNoSelection}
                        includeSelectAll = {true}
                        values={mapEnumToFilterValues(SiteStatus)}
                    />
                </div>
                <div className="cell">
                    <DropdownFilter 
                        fieldName="provisioningStatus"
                        //urlFetch= '/ProvisioningStatus?q=all'
                        title = 'Technical Status'
                        onChange = {onFilterChange}
                        noselection = {handleNoSelection}
                        includeSelectAll = {true}
                        values={mapEnumToFilterValues(ProvisioningStatus)}
                    />
                </div>
                <div className="cell">
                    <DropdownFilter 
                        fieldName='confidentiality'
                        //urlFetch='/ConfidentalLevel?q=all'
                        title='Sensitivity Label'
                        onChange = {onFilterChange}
                        noselection = {handleNoSelection}
                        values={mapEnumToFilterValues(ConfidentialityLevel)}
                    />
                </div>
                <div className="cell">
                    <DropdownFilter 
                        fieldName='location'
                        urlFetch= '/Location'
                        title = 'Location'
                        optionFieldName='name'
                        onChange = {onFilterChange}
                        noselection = {handleNoSelection}
                    />
                </div>
                <div className="cell">
                    <DropdownFilter 
                        fieldName="template"
                        urlFetch= '/Template?getAll=true'
                        title = 'Template'
                        optionFieldName='name'
                        onChange = {onFilterChange}
                        noselection = {handleNoSelection}
                        group = {true}
                        includeSelectAll = {true}
                    />
                </div>
                <div className="cell">
                    <DropdownTree
                        fieldName="management"
                        address = {'/Management?parent='}
                        label = 'Organization'
                        multiselect = {false}
                        onChange = {onFilterChange}
                        />
                </div>
                <div className="cell">
                    <DropdownTree
                        fieldName="geography"
                        address = {'/Geography?parent='}
                        label = 'Site Audience'
                        multiselect = {true}
                        onChange = {onFilterChange}
                        includeCrossOrg={true}
                    />
                </div>
                <div className="cell">
                    <DropdownFilter 
                        fieldName="attentionType"
                        //urlFetch= '/AttentionType'
                        title = 'Attention'
                        onChange = {onFilterChange}
                        defaultEmpty
                        values = {[
                            ...mapEnumToFilterValues(AttentionType),
                            {key: 'litigationHold', value: 'Litigation Hold'},
                            {key: 'keepReadOnly', value: 'Keep in read-only mode'}
                        ]}
                    />
                </div>
                <div className="cell">
                    <DropdownFilter fieldName="tasks"
                        //urlFetch='/TasksFilter'
                        title="Pending tasks"
                        onChange={onFilterChange}
                        includeSelectAll={true}
                        multiSelect={true}
                        defaultEmpty
                        values={mapEnumToFilterValues(TasksFilter)}
                    />
                </div>
                <div className="cell">
                    <TextFilter
                        fieldName='customApplication'
                        fieldLabel='Custom Application'
                        onChange={onFilterChange}
                    />
                </div>
            </div>
            <div style={{position:'relative', margin: '20px 0'}}>
                <div>
                    <IconButton 
                        style={{color: 'rgb(96, 94, 92)', position: 'absolute'}} 
                        onClick={updateResults} 
                        iconProps={{iconName: 'refresh'}} 
                        />
                    <PageNavi
                        pageNumPart = {setPageUrlFilter}
                        totalResults = {totalResults}
                        resultsOnPage = {onPage}
                        pageNum = {pageUrlFilter}
                        showTotalResults = {true}
                        />
                    
                    <Stack horizontal disableShrink>
                        <ResultsOnPage
                            onPage = {onPage}
                            onPageResults = {setOnPage}
                            />
                        <ExportButton 
                            onClick = {exportSites}
                            loading = {isExporting}
                            >                           
                        </ExportButton>
                    </Stack>
                    
                </div>
            </div>
            {
                <SiteItemsList 
                    isLoading={isLoading}
                    results={sites} 
                    filters={filters}
                    orderedBy={orderBy}
                    sortItems={sortItems}
                />
            }
        </div>
    );    
}


export default SiteList


// WEBPACK FOOTER //
// ./src/components/Administration/SiteList.js